module.exports = __webpack_public_path__ + "static/media/gp.1827a83f.svg";